// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3Q-BZ","searchInvalid":"Search_searchInvalid__3DN81","input":"Search_input__3iTQH","btn":"Search_btn__VNvBO"};